import React, { useState, useEffect } from "react";
import OwlCarousel from "react-owl-carousel3";

const Testimonials = [
  {
    name: "Lissa Castro",
    role: "Designer",
    image: "assets/images/user_img1.jpg",
    text: "Fexila makes managing my store effortless. Products, sliders, and popups set up in minutes with seamless API integration.",
  },
  {
    name: "Alden Smith",
    role: "Designer",
    image: "assets/images/user_img2.jpg",
    text: "Fexila simplifies running multiple stores. Products, campaigns, and APIs are seamless, the dashboard intuitive, saving me hours every week.",
  },
  {
    name: "Daisy Lana",
    role: "Designer",
    image: "assets/images/user_img3.jpg",
    text: "Fexila transformed managing my stores. Fast, reliable, handling inventory to invoices effortlessly. Switching plans is seamless, and support is always helpful.",
  },
  {
    name: "John Becker",
    role: "Designer",
    image: "assets/images/user_img4.jpg",
    text: "Managing my store is effortless with Fexila. Products, campaigns, and invoices set up easily—fast, simple, and stress-free.",
  },
];

const Testimonial = () => {
  const [display, setDisplay] = useState(false);

  const options = {
    loop: true,
    margin: 20,
    nav: true,
    center: true,
    dots: false,
    autoplay: true,
    items: 1,
    navText: [
      '<i class="ion-ios-arrow-left"></i>',
      '<i class="ion-ios-arrow-right"></i>',
    ],
  };

  useEffect(() => {
    setDisplay(true); // Only render carousel on client
  }, []);

  return (
    <section className="section bg_redon bg-light text-dark testimonial position-relative">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h2 className="text-dark text-center mb-3 fw-bold">
              What Our Clients Say
            </h2>
            <div className="col-lg-7 col-md-6 mx-auto">
              <p className="text-center" style={{ marginBottom: "5rem" }}>
                Hear some of Our Satisfied Clients—Real Stories of their Success
                and Exceptional Experiences.
              </p>
            </div>

            {display && (
              <div className="testimonial_wrap testimonial_style1 carousel_slider owl-theme nav_style2">
                <OwlCarousel {...options}>
                  {Testimonials.map((testimonial, index) => (
                    <div className="testimonial_box" key={index}>
                      <div className="author_wrap">
                        <div className="author_img">
                          <img
                            src={testimonial.image}
                            alt={testimonial.name}
                            className="rounded-5"
                          />
                        </div>
                        <div className="author_name">
                          <h6>{testimonial.name}</h6>
                          <span>{testimonial.role}</span>
                        </div>
                      </div>
                      <div className="testimonial_desc">
                        <p>{testimonial.text}</p>
                      </div>
                      <div className="text-center star-icons">
                        <i className="bi bi-star-fill me-1"></i>
                        <i className="bi bi-star-fill me-1"></i>
                        <i className="bi bi-star-fill me-1"></i>
                        <i className="bi bi-star-fill me-1"></i>
                        <i className="bi bi-star-fill"></i>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
